import { render, staticRenderFns } from "./SupportUpdate.vue?vue&type=template&id=6e81c5bb&scoped=true"
import script from "./SupportUpdate.vue?vue&type=script&lang=js"
export * from "./SupportUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e81c5bb",
  null
  
)

export default component.exports